import React from "react";
import intl from "react-intl-universal";

import {AuthModalHeader} from "../../AuthModal";

import "./RequestAccessHint.css";


interface RequestAccessHintProps {
    teamSlug: string;
}

export const RequestAccessHint = ({teamSlug}: RequestAccessHintProps) => {
    return (
        <div className="RequestAccessHint">
            <AuthModalHeader title={intl.get('sign_up.request_access.title').d('Request an invite')}/>
            <div className="RequestAccessHint__body body-large">
                {intl.get('sign_up.request_access.body').d('This workspace requires an invite link from an admin before you can create an account.')}
            </div>
            <div className="RequestAccessHint__team label-large">
                {teamSlug}
            </div>
        </div>
    );
}
